import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PublicLayout from "../../components/public/Layout/layout";
import Header from "../../components/student/Header/index";
import Categories from "../../containers/student/home/categories";
import DownloadAppComp from "../../containers/student/home/downloadAppComp";
import LatestCourses from "../../containers/student/home/latestCourses";
import RecordesComp from "../../containers/student/home/recordes";
import Subjects from "../../containers/student/home/subjects";
import Teachers from "../../containers/student/home/teachers";
import {
  getAllSubjectsRequest,
  getAllTeachersRequest,
} from "../../modules/public/publicData/Actions";
import { getUserDataRequest } from "../../modules/user/Actions";

const Home = () => {
  const dispatch = useDispatch();
  const token = window.localStorage.getItem("token");
  const { teachers, subjects } = useSelector((state) => state.public);
  const userData = useSelector((state) => state.user.userData);

  useEffect(() => {
    if (token) {
      dispatch(getUserDataRequest());
    }
  }, [token]);

  useEffect(() => {
    dispatch(getAllSubjectsRequest());
    dispatch(getAllTeachersRequest());
  }, []);

  return (
    <PublicLayout
      color="white"
      bg="main_1"
      register={userData?.id ? false : true}
    >
      <Header />
      <Categories />
      <Subjects />
      <Teachers />
      <LatestCourses />
      {/* <RegisterComp /> */}
      <RecordesComp />
      {/* <SummeryComp /> */}
      {/* <StudentComp /> */}
      {/* <ReviewsComp /> */}
      <DownloadAppComp />
      {/* <AboutUs />
      <ContsctUs />
      <News /> */}
    </PublicLayout>
  );
};

export default Home;
